module.exports = __webpack_public_path__ + "static/media/Zoom_and_Cialfo.ae12da21.png";